import { diagnosticLog } from './diagnosticLogger';

export type GridEntryView = 'albums' | 'artists' | 'recent' | string;

export type GridEntryPhaseMap = Record<string, number>;

type PendingGridEntry = {
  entryView: GridEntryView;
  albumCount: number;
  reentry: boolean;
  phases: GridEntryPhaseMap;
};

let pendingEntry: PendingGridEntry | null = null;
const emittedEntryKeys = new Set<string>();

/** Seconds since this web bundle loaded (navigation start). */
export function getSessionUptimeSeconds(): number {
  if (typeof performance === 'undefined') return 0;
  return Math.round(performance.now() / 1000);
}

export function beginGridEntryTiming(
  entryView: GridEntryView,
  albumCount: number,
  reentry = false,
): void {
  pendingEntry = {
    entryView,
    albumCount,
    reentry,
    phases: {},
  };
}

export function markGridEntryPhaseStart(): number {
  return typeof performance !== 'undefined' ? performance.now() : 0;
}

export function recordGridEntryPhase(phase: string, ms: number): void {
  if (!pendingEntry) return;
  pendingEntry.phases[phase] = Math.round(ms * 10) / 10;
}

export function finishGridEntryPhase(phase: string, startMs: number): void {
  if (!startMs) return;
  recordGridEntryPhase(phase, performance.now() - startMs);
}

/** Emit once per grid entry — js:perf line with phase_ms map. */
export function emitGridEntryPerf(entryToken?: string): void {
  if (!pendingEntry) return;
  const token = entryToken
    ?? `${pendingEntry.entryView}:${pendingEntry.albumCount}:${pendingEntry.reentry ? 'r' : 'f'}`;
  if (emittedEntryKeys.has(token)) return;
  emittedEntryKeys.add(token);

  diagnosticLog('info', 'js:perf', 'js:perf', {
    kind: 'grid_entry',
    entry_view: pendingEntry.entryView,
    album_count: pendingEntry.albumCount,
    reentry: pendingEntry.reentry,
    phase_ms: { ...pendingEntry.phases },
    session_uptime_s: getSessionUptimeSeconds(),
  });
  pendingEntry = null;
}

export function resetGridEntryPerfForTests(): void {
  pendingEntry = null;
  emittedEntryKeys.clear();
}
